__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2026-11-04-1793788438-stable-dev/";